import React from 'react'

import Box from '@mui/material/Box'
import { useIntl } from 'react-intl'

import { UserRole } from '@/types'
import IconButton from '@/components/Button/IconButton'
import ShareLoanActionsIcon from './ShareLoanActionsIcon'

type ShareLoanActionsCellProps = {
	row: UserRole
	disabled?: boolean
	onRevokeUser: (userId: string) => void
}

const ShareLoanActionsCell = ({
	row,
	disabled,
	onRevokeUser,
}: ShareLoanActionsCellProps) => {
	const { formatMessage } = useIntl()

	const title = formatMessage({
		id: 'remove_record.remove',
	})

	const handleRevokeUser = () => onRevokeUser(row.user.id)

	return (
		<Box sx={{ display: 'flex', gap: 1 }}>
			<IconButton
				title={title}
				size="small"
				color="error"
				onClick={handleRevokeUser}
				disabled={disabled}
			>
				<ShareLoanActionsIcon
					contentType={row.loadingRevoke ? 'loading' : 'delete'}
				/>
			</IconButton>
		</Box>
	)
}

export default ShareLoanActionsCell
